import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Edit, Trash2, Check, Factory } from "lucide-react";
import { Industry } from "@/types/industry";

interface IndustriesTableProps {
  industries: Industry[];
  onEdit: (industry: Industry) => void;
  onDelete: (industry: Industry) => void;
}

export function IndustriesTable({
  industries,
  onEdit,
  onDelete,
}: IndustriesTableProps) {
  return (
    <Card className="rounded-[20px] overflow-hidden border border-slate-100 shadow-sm">
      <CardContent className="p-0">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-slate-100 border-b border-slate-200">
              <tr>
                <th className="px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase tracking-wider">
                  Nombre
                </th>
                <th className="px-6 py-4 text-left text-xs font-bold text-slate-700 uppercase tracking-wider">
                  Estado
                </th>
                <th className="px-6 py-4 text-right text-xs font-bold text-slate-700 uppercase tracking-wider">
                  Acciones
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-slate-50">
              {industries.length === 0 ? (
                <tr>
                  <td
                    colSpan={3}
                    className="px-6 py-12 text-center text-slate-500"
                  >
                    <div className="flex flex-col items-center justify-center">
                      <Factory className="h-12 w-12 text-slate-300 mb-2" />
                      <p>No hay industrias registradas</p>
                    </div>
                  </td>
                </tr>
              ) : (
                industries.map((industry) => (
                  <tr key={industry.id} className="hover:bg-slate-50/50 transition-colors group">
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="text-sm font-medium text-slate-700 group-hover:text-slate-900 transition-colors">
                        {industry.name}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      {industry.is_default && (
                        <Badge
                          variant="secondary"
                          className="bg-indigo-50 text-indigo-700 hover:bg-indigo-100 border border-indigo-100/50"
                        >
                          <Check className="h-3 w-3 mr-1" /> Por defecto
                        </Badge>
                      )}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                      <div className="flex items-center justify-end gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                        <Button
                          variant="ghost"
                          size="icon"
                          onClick={() => onEdit(industry)}
                          className="h-8 w-8 rounded-full text-indigo-600 hover:text-indigo-700 hover:bg-indigo-50"
                        >
                          <Edit className="h-4 w-4" />
                        </Button>
                        <Button
                          variant="ghost"
                          size="icon"
                          onClick={() => onDelete(industry)}
                          className="h-8 w-8 rounded-full text-red-500 hover:text-red-700 hover:bg-red-50"
                        >
                          <Trash2 className="h-4 w-4" />
                        </Button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </CardContent>
    </Card>
  );
}
